import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=b10c18e6&"
import script from "./BillingSummary.vue?vue&type=script&lang=js&"
export * from "./BillingSummary.vue?vue&type=script&lang=js&"
import style0 from "./BillingSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports